let message = {
  sendMsgNet: {
    //发送短信

    /***发送结果不会立即返回，第三方可根据发送短信结果通知 获取
    **/
    url: '/scooper-sms/data/message/sendMsg',
    requestParam: {
      token: '',
      caller: '',
      //发送人号码 
      callees: '',
      //收件人号码 多个号码用英文分号“;”分割
      content: '' //短信内容，最长512个字节（汉字算两个字节）

    },
    responseParam: {
      code: '',
      //返回结果状态码
      message: '',
      systemTime: '',
      //yyyy-MM-dd HH:mm:ss
      data: {
        msgId: '',
        //短信记录id 短信超过50条会分批次发送，返回结果有多个msgId，中间用“;”分割
        flagBatch: '' //0 - 非群发 1 - 群发

      }
    }
  },
  queryMsgSendNet: {
    //分页查询发送短信记录列表

    /***短信发送记录 分页查询接口，支持条件查询
     * 普通成员只能查询自己发送短信记录，如需查询所有发送短信记录，需在对应账号上开通该权限
    **/
    url: '/scooper-sms/data/message/queryMsgSend',
    requestParam: {
      token: '',
      caller: '',
      //发送人号码 
      callee: '',
      //收件人号码 多个号码用英文分号“;”分割
      content: '',
      //短信内容，最长512个字节（汉字算两个字节）
      flagBatch: '',
      //是否群发 0：非群发 1、群发 2、所有（默认）
      startTime: '',
      endTime: '',
      msgStatus: '',
      //发送状态【-1：全部；0：等待发送；1：发送中；2：发送成功；3：发送失败；4：发送超时】
      pageNumber: '',
      //查询页码
      pageSize: ''
    },
    responseParam: {
      code: '',
      //返回结果状态码
      message: '',
      systemTime: '',
      //yyyy-MM-dd HH:mm:ss
      data: {
        totalRow: '',
        list: [{
          //记录列表， [0, n]个sendMsg。
          id: '',
          caller: '',
          callee: '',
          flag_batch: '',
          msg_status: '',
          //短信发送状态 0:等待发送,1:发送中，2:发送成功，3:发送失败，4:发送超时
          time_send: '',
          sms_content: '',
          //短信发送内容
          succ_callee: '',
          //发送成功的收件人数
          total_callee: '',
          //总共的收件人数
          time_schedule: '',
          //定时发送的时间
          reply_read: '' //回复是否已读（0：未读 1：已读）

        }],
        firstPage: '',
        //是否首页
        lastPage: '',
        //是否尾页
        pageNumber: '',
        //当前页
        pageSize: '',
        totalPage: ''
      }
    }
  },
  findMsgSendByIdNet: {
    //查询（单条）发送短信记录

    /***根据发送短信记录id查询发送短信消息记录
    **/
    url: '/scooper-sms/data/message/queryMsgSend',
    requestParam: {
      token: '',
      msgId: '' //短信记录id

    },
    responseParam: {
      code: '',
      //返回结果状态码
      message: '',
      systemTime: '',
      //yyyy-MM-dd HH:mm:ss
      data: {
        id: '',
        caller: '',
        callee: '',
        formatedCallee: '',
        //收件人姓名(号码)查找不到姓名时，该字段与callee内容相同
        flag_batch: '',
        msg_status: '',
        // 短信发送状态 0:等待发送,  1:发送中， 2:发送成功，3:发送失败， 4:发送超时
        time_send: '',
        //短信发送时间
        sms_content: '' //短信发送内容

      }
    }
  },
  findBatchResultNet: {
    //查询群发短信（单个）发送状态

    /***查询群发短信结果，获取单条群发短信每个接收者的接收状态
    **/
    url: '/scooper-sms/data/message/findBatchResult',
    requestParam: {
      token: '',
      msgId: '' //短信记录id

    },
    responseParam: {
      code: '',
      //返回结果状态码
      message: '',
      systemTime: '',
      //yyyy-MM-dd HH:mm:ss
      data: {
        total: '',
        list: [{
          callee: '',
          //接收号码
          memName: '',
          //接收人员姓名
          reason: '',
          //发送状态，0:等待发送,1:发送中，2:发送成功，3:发送失败,4:发送超时
          id: '',
          // 群发id
          tx_id: '' //发送的短信id

        }]
      }
    }
  },
  deleteMsgSendNet: {
    //删除发送短信记录

    /***不能删除发送短信状态为【0:等待发送，1:发送中的短信记录】。
    **/
    url: '/scooper-sms/data/message/deleteMsgSend',
    requestParam: {
      token: '',
      msgId: '' //短信记录id

    },
    responseParam: {
      code: '',
      //返回结果状态码
      message: '',
      systemTime: '',
      //yyyy-MM-dd HH:mm:ss
      data: {}
    }
  },

  /***
   * 接收短信
   */
  queryMsgRecvNet: {
    //分页查询接收短信记录列表

    /***短信接收记录分页查询接口，支持条件查询。
    **/
    url: '/scooper-sms/data/message/queryMsgRecv',
    requestParam: {
      token: '',
      caller: '',
      //短信记录id
      callee: '',
      content: '',
      startTime: '',
      endTime: '',
      msgStatus: '',
      //接收短信状态 0：未读 1:已获取,  2:已读
      pageNumber: '',
      pageSize: ''
    },
    responseParam: {
      code: '',
      //返回结果状态码
      message: '',
      systemTime: '',
      //yyyy-MM-dd HH:mm:ss
      data: {
        totalRow: '',
        pageNumber: '',
        list: [{
          id: '',
          //短信id
          caller: '',
          callee: '',
          msg_status: '',
          //短信接收状态0：未读  1：已获取  2：已读
          time_recv: '',
          //短信接收时间
          sms_content: '',
          //短信接收内容
          succ_callee: '',
          //发送成功的收件人数量
          total_callee: '' //总共的收件人数量

        }],
        lastPage: '',
        firstPage: '',
        pageSize: '',
        totalPage: ''
      }
    }
  },
  findMsgRecvByIdNet: {
    //查询单条接收短信记录

    /***根据接收短信记录id查询接收短信消息记录
    **/
    url: '/scooper-sms/data/message/findMsgRecvById',
    requestParam: {
      token: '',
      msgId: '' //短信记录id

    },
    responseParam: {
      code: '',
      //返回结果状态码
      message: '',
      systemTime: '',
      //yyyy-MM-dd HH:mm:ss
      data: {
        id: '',
        //短信id
        caller: '',
        callee: '',
        msg_status: '',
        //短信接收状态0：未读  1：已获取  2：已读
        time_recv: '',
        //短信接收时间
        sms_content: '',
        //短信接收内容
        msg_type: '' //消息类型0：sms，1：mms

      }
    }
  },
  updateRecvStatusNet: {
    //阅读接收短信记录

    /***阅读接收短信记录。将接收到的短信记录标记为已读状态
    **/
    url: '/scooper-sms/data/message/updateRecvStatus',
    method: 'POST',
    requestParam: {
      token: '',
      msgId: '' //短信记录id

    },
    responseParam: {
      code: '',
      //返回结果状态码
      message: '',
      systemTime: '',
      //yyyy-MM-dd HH:mm:ss
      data: {
        unReadNum: 1 //未读接收短信数量

      }
    }
  },
  getUnReadRecvNumNet: {
    //查询未读接收短信记录数量

    /***阅读接收短信。将接收到的短信标记为已读状态
    **/
    url: '/scooper-sms/data/message/getUnReadRecvNum',
    requestParam: {
      token: '',
      //短信记录id
      msgId: ''
    },
    responseParam: {
      code: '',
      //返回结果状态码
      message: '',
      systemTime: '',
      //yyyy-MM-dd HH:mm:ss
      data: {
        total: 1 //未读接收短信剩余总数

      }
    }
  },

  /**
   * MQTT订阅
   * @param {*} accId 
   * @returns 
   */
  sendMsgMQNet: function () {
    return {
      //发送短信通知
      topic: '/scooper-sms/notify/msg/sendMsg',
      responseParam: {
        id: 0,
        //短信id
        type: 'sendMsg',
        //消息类别
        source: 'scooper-sms',
        //消息来源
        data: {
          msgId: '' //短信ID

        }
      }
    };
  },
  sendMsgResultMQNet: function () {
    return {
      //发送短信结果通知
      topic: '/scooper-sms/notify/msg/sendMsgResult',
      responseParam: {
        id: 0,
        //短信id
        type: 'sendMsgResult',
        //消息类别
        source: 'scooper-sms',
        //消息来源
        data: {
          msgStatus: '' //短信发送状态 2:发送成功，3:发送失败，4:发送超时

        }
      }
    };
  },
  deleteMsgSendMQNet: function () {
    return {
      //删除发送短信记录通知
      topic: '/scooper-sms/notify/msg/deleteMsgSend',
      responseParam: {
        id: 0,
        //短信id
        type: 'deleteMsgSend',
        //消息类别
        source: 'scooper-sms',
        //消息来源
        data: {}
      }
    };
  },
  recvMsgMQNet: function () {
    return {
      //接收到短信通知
      topic: '/scooper-sms/notify/msg/recvMsg',
      responseParam: {
        id: 0,
        //短信id
        type: 'recvMsg',
        //消息类别
        source: 'scooper-sms',
        //消息来源
        data: {
          total: '' //未读接收短信剩余总数

        }
      }
    };
  },
  deleteMsgRecvMQNet: function () {
    return {
      //删除接收短信记录通知
      topic: '/scooper-sms/notify/msg/deleteMsgRecv',
      responseParam: {
        id: 0,
        //短信id
        type: 'deleteMsgRecv',
        //消息类别
        source: 'scooper-sms',
        //消息来源
        data: {
          total: '' //未读接收短信剩余总数

        }
      }
    };
  },
  readMsgRecvMQNet: function () {
    return {
      //阅读接收短信记录通知
      topic: '/scooper-sms/notify/msg/readMsgRecv',
      responseParam: {
        id: 0,
        //短信id
        type: 'readMsgRecv',
        //消息类别
        source: 'scooper-sms',
        //消息来源
        data: {
          unReadNum: '' //未读接收短信剩余总数

        }
      }
    };
  },

  /**
   * 
   * @returns HTTP推送
   */
  sendMsgHttpNet: function () {
    /**
     * 推送发送短信通知，用于短信发送列表数据刷新显示
     */
    return {
      //发送短信通知
      url: '/notify/msg/sendMsg',
      method: 'POST',
      requestParam: {
        msgId: '' //短信记录id

      },
      responseParam: {
        code: '' //操作结果代码

      }
    };
  },
  sendMsgResultHttpNet: function () {
    /**
     * 推送发送短信结果通知，用于短信发送状态刷新显示
     */
    return {
      //发送短信结果通知
      url: '/notify/msg/sendMsgResult',
      method: 'POST',
      requestParam: {
        msgId: '',
        //短信记录id 
        msgStatus: '' //短信发送状态 2:发送成功，3:发送失败，4:发送超时

      },
      responseParam: {
        code: '' //操作结果代码

      }
    };
  },
  deleteMsgSendHttpNet: function () {
    /**
     * 推送删除发送短信结果通知，用于短信列表数据刷新显示
     */
    return {
      //删除发送短信记录通知
      url: '/notify/msg/deleteMsgSend',
      method: 'POST',
      requestParam: {
        msgId: '' //短信记录id 

      },
      responseParam: {
        code: '' //操作结果代码

      }
    };
  },
  recvMsgHttpNet: function () {
    /**
     * 接收到新短信通知，用于短信接收列表刷新和未读数量刷新显示
     */
    return {
      //接收到短信通知
      url: '/notify/msg/recvMsg',
      method: 'POST',
      requestParam: {
        msgId: '',
        //接收短信id
        total: '' //未读接收短信剩余总数

      },
      responseParam: {
        code: '' //操作结果代码

      }
    };
  },
  deleteMsgRecvHttpNet: function () {
    /**
     * 接收到新短信通知，用于短信接收列表刷新和未读数量刷新显示
     */
    return {
      //删除接收短信记录通知
      url: '/notify/msg/deleteMsgRecv',
      method: 'POST',
      requestParam: {
        msgId: '',
        //接收短信id
        total: '' //未读接收短信剩余总数

      },
      responseParam: {
        code: '' //操作结果代码

      }
    };
  },
  readMsgRecvHttpNet: function () {
    /**
     * 阅读接收短信结果通知，用于接收短信阅读状态刷新显示和未读数量刷新显示
     */
    return {
      //阅读接收短信记录通知
      url: '/notify/msg/readMsgRecv',
      method: 'POST',
      requestParam: {
        msgId: '',
        //接收短信id
        unReadNum: '' //未读接收短信剩余总数

      },
      responseParam: {
        code: '' //操作结果代码

      }
    };
  }
};
export default message;